import { connect } from 'react-redux';
import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../../redux';
import { rowClick, downloadURL, onbulkDownload, onBulkDownloadStl, onBulkDownloadIndividual } from 'src/actions/completeOrderAction';
import { RowDataCompleted } from 'src/reducers/completeorderfile';
import CompleteOrderPageDate from './CompletedOrderPageDate';
import { savefromDate, savefromTime, savetoDate, savetoTime, getArchiveData } from 'src/actions/completedOrderDateAction';
import { openVideoPlayerURLArray } from 'src/actions/landingPageAction';
import { SHOW_FAILED_FILES_DIALOG } from '../../reducers/completeorderfile';

export const mapStateToProps = (state: AppState) => {
    return {
        completeOrderDataDate: state.completeOrder.completeOrderDataDate,
        completeOrderDataExport: state.completeOrder.completeOrderDataExport,
        isDownloading: state.completeOrder.isDownloading,
        startDate: state.completeOrder.startDate,
        endDate: state.completeOrder.endDate,
        startTime: state.completeOrder.startTime,
        endTime: state.completeOrder.endTime,
         // New properties for failed files dialog
         failedFiles: state.completeOrder.failedFiles,
         showFailedFilesDialog: state.completeOrder.showFailedFilesDialog,
         failedFilesMessage: state.completeOrder.failedFilesMessage,
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onComponentDidMount: () => {
            // dispatch(getArchiveData('get'));
        },
        reload: () => {
            dispatch(getArchiveData('get'));
        },
        onRowClick: (orderid: string, rowData: string) => {
            dispatch(rowClick(orderid, rowData));
        },
        onDownloadClick: (filepath: string, fileName: string) => {
            dispatch(downloadURL(filepath, fileName, 'Final Scan'));
        },
        onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onbulkDownload(completedData, true));
        },
        onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => {
            dispatch(onBulkDownloadStl(completedData, filetype, true));
        },
        fDate: (fromDate: Date | null) => {
            dispatch(savefromDate(fromDate));
        },
        fTime: (fromTime: Date | null) => {
            dispatch(savefromTime(fromTime));
        },
        toDate: (toDate: Date | null) => {
            dispatch(savetoDate(toDate));
        },
        toTime: (toTime: Date | null) => {
            dispatch(savetoTime(toTime));
        },
        dateFilter: () => {
            dispatch(getArchiveData('get'));
        },
        dateReset: () => {
            dispatch(getArchiveData('reset'));
        },
        openVideoPlayerURL: (fullPath: string[], fpath: string) => {
            dispatch(openVideoPlayerURLArray(fullPath, fpath));
        },
        onBulkDownloadIndividual: (completedData: RowDataCompleted[] | RowDataCompleted) => {
            dispatch(onBulkDownloadIndividual(completedData, true));
        },
        closeFailedFilesDialog: () => {
            dispatch({ type: SHOW_FAILED_FILES_DIALOG, showFailedFilesDialog: false } as AnyAction);
        },
    };
};

const CompleteOrderContainerDate = connect(
    mapStateToProps,
    mapDispatchToProps,
)(CompleteOrderPageDate);

export default CompleteOrderContainerDate;



// WEBPACK FOOTER //
// ./src/components/CompletedOrderPageDate/CompletedOrderPageContainerDate.tsx